import React from 'react'
import PropTypes from 'prop-types'

const FormFieldTitle = ({ title, className }) => (
  <div className="form-subtitle text-gray-900">
    <h5 className={`text-xs pb-1 font-semibold border-b-2 border-primary-darkgray ${className}`}>
      {title}
    </h5>
  </div>
)

FormFieldTitle.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default FormFieldTitle
